import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPinOutline = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M7 3.499a9.33 9.33 0 0 1 5-1.442A9.33 9.33 0 0 1 17 3.5a8.589 8.589 0 0 1 3.285 3.805c.67 1.54.845 3.231.504 4.862a8.334 8.334 0 0 1-2.433 4.326l-5.293 5.037a1.542 1.542 0 0 1-1.062.414c-.41 0-.79-.155-1.063-.414l-5.294-5.037a8.333 8.333 0 0 1-2.433-4.326 8.035 8.035 0 0 1 .504-4.862A8.589 8.589 0 0 1 7 3.5Zm15.786 9.09a10.395 10.395 0 0 1-3.029 5.399l-5.293 5.037c-.663.63-1.55.975-2.463.975a3.579 3.579 0 0 1-2.464-.975l-5.294-5.037a10.394 10.394 0 0 1-3.03-5.398 10.107 10.107 0 0 1 .633-6.112c.84-1.93 2.258-3.57 4.065-4.719A11.359 11.359 0 0 1 12 0c2.163 0 4.282.61 6.089 1.76a10.64 10.64 0 0 1 4.065 4.718c.84 1.93 1.062 4.058.632 6.112Zm-8.972-2.418c0 1.01-.812 1.829-1.814 1.829a1.822 1.822 0 0 1-1.814-1.829c0-1.01.812-1.828 1.814-1.828s1.815.819 1.815 1.828Zm1.815 0c0 2.02-1.625 3.658-3.629 3.658-1.963 0-3.563-1.572-3.627-3.535a3.66 3.66 0 0 1 1.284-2.915A3.598 3.598 0 0 1 12 6.514c2.004 0 3.629 1.638 3.629 3.657Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgPinOutline);
export default ForwardRef;
